import { useParams } from 'react-router-dom';
import Breadcrumbs from 'style-guide/Breadcrumbs';
import Button from 'style-guide/Button';

const SurveyHeader = ({ name, setIsPreview, isPreview }) => {
  const { seriesName, surveyId } = useParams();

  const items = [
    {
      label: 'Surveys',
      key: 'surveys',
    },
    {
      label: name || 'Survey name goes here',
      key: 'survey-name',
      url: `/survey/create/${seriesName}/${surveyId}`,
    },
  ];

  return (
    <div className='d-flex justify-content-between align-items-center mv--16 mh--32'>
      <Breadcrumbs items={items} />
      {!isPreview ? (
        <div className='d-flex'>
          <Button variant='secondary' onClick={() => setIsPreview(true)}>
            Preview
          </Button>

          {/* ToDo: remove the Publish button comment after adding logic */}

          {/* <Button variant='primary' className='ml--8' disabled={publishDisabled} onClick={publishSurvey}>
            Publish
          </Button> */}
        </div>
      ) : (
        <div className='d-flex'>
          <Button variant='secondary' onClick={() => setIsPreview(false)}>
            Edit
          </Button>
        </div>
      )}
    </div>
  );
};
export default SurveyHeader;
